/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import Chip from '@material-ui/core/Chip';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@mui/material/TableFooter';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _, { result } from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';

var screenCode = "QUANTITYBOUGHTAGAINSTPURCHASEORDERREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function QuantityBoughtAgainstPurchaseOrderReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const onKeyDown = (e) => {
        e.preventDefault();
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [reportData, setReportData] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        productCategoryID: '',
        productID: '',
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
        isActive: true
    });
    const [totalValues, setTotalValues] = useState({
        totalOrderedQty: 0,
        totalSuppliedQty: 0,
        totalFillRate: 0
    });

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - reportData.length) : 0;


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const productAvailabilitySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
        productCategoryID: Yup.array().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.array().min(1, 'Please Select Product').required('Product Required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required'),
        toDate: Yup.date().min(1).min(1, 'Please Select End Date').required('Start end required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        productCategoryID: '',
        productID: '',
        fromDate: '',
        toDate: '',
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            productCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: productAvailabilitySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    useEffect(() => {
        getPermissions()
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWQUANTITYBOUGHTAGAINSTPURCHASEORDERREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    async function SubmitForm() {
        setReportData([])
        var newRes = await services.GetQuantityBoughtAgainstPurchaseOrderReportDetails(
            selectedOptions.map(x => x).join(',').toString(),
            selectedProductOptions.map(x => x).join(',').toString(),
            (fromDate).toISOString(),
            (toDate).toISOString()
        );

        newRes.sort((a, b) => a.orderDate < b.orderDate ? 1 : -1);
        setReportData(newRes)

        let model = {
            GroupID: formik.values.groupID,
            OperationEntityID: selectedOptions.map(x => x).join(',').toString(),
            Product: selectedProductOptions.map(x => x).join(',').toString(),
            FromDate: (fromDate).toISOString(),
            ToDate: (toDate).toISOString()
        }
        createDataForExcel(newRes);
        getSelectedDropdownValuesForReport(model);
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setReportData([]);
            setSelectedCategoryOptions([])
            setFromDate(new Date());
            setToDate(new Date());
            setSelectedProductOptions([]);
            setSelectedOptions([]);
        } else {
            setSelectedCategoryOptions([]);
            setFromDate(new Date());
            setToDate(new Date());
            setSelectedOptions([]);
            setSelectedProductOptions([]);
        }
    }

    useEffect(() => {
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [selectedCategoryOptions]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [formik.values.productID]);

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [fromDate]);

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [toDate]);

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [selectedOptions]);

    useEffect(() => {
        setPage(0);
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            productCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions
        })
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);

    useEffect(() => {
        setPage(0);
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setPage(0);
        setReportData([]);
    }, [selectedProductOptions])

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])

    useEffect(() => {
        setPage(0);
        if (reportData.length != 0) {
            calculateTotal()
        }
    }, [reportData]);

    useEffect(() => {
        setPage(0);
        setSelectedProductOptions([])
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setPage(0);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
    }, [formik.values.operationEntityID]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    function calculateTotal() {

        const totalOrderedQty = reportData.reduce((accumulator, current) => {
            const progressFraction = current.orderedQty;
            return accumulator + progressFraction;
        }, 0);

        const totalSuppliedQty = reportData.reduce((accumulator, current) => {
            const progressFraction = current.suppliedQty;
            return accumulator + progressFraction;
        }, 0);

        const totalFillRate = totalOrderedQty > 0 
        ? ((totalSuppliedQty / totalOrderedQty) * 100).toFixed(2) 
        : 0;


        setTotalValues({
            ...totalValues,
            totalOrderedQty: totalOrderedQty,
            totalSuppliedQty: totalSuppliedQty,
            totalFillRate: totalFillRate
        });
    }

    async function createFile(array) {
        var file = await createDataForExcel(reportData);
        var settings = {
            sheetName: 'Qty Bought against PO-SKU Wise',
            fileName: 'SKU Wise Quantity Bought against Purchase Order',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Qty Bought against PO-SKU Wise',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Date': moment(x.orderDate).format("YYYY-MM-DD"),
                    'FCC': x.factoryName,
                    'SKU Code': x.skuCode,
                    'SKU Description': x.skuDescription,
                    'Ordered Qty': x.orderedQty == 0 ? '-' : parseFloat(x.orderedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}),                    
                    'Supplied Qty': x.suppliedQty == 0 ? '-' : parseFloat(x.suppliedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                    'Fill Rate': getFillRate(x) == 0 ? '-' : parseFloat(getFillRate(x)).toFixed(2)
                }
                res.push(vr);
            });
            var vrTotal = {
                'Order Date': "Total",
                'Ordered Qty': totalValues.totalOrderedQty.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                'Supplied Qty': totalValues.totalSuppliedQty.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                'Fill Rate':totalValues.totalFillRate
            }
            res.push(vrTotal);
            res.push({});
        }
        return res;
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(selectedCategoryOptions.length === productcatogery.length ? [] : productcatogery.map((option) => option.value));
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(selectedProductOptions.length === product.length ? [] : product.map((option) => option.value));
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    function getSelectedDropdownValuesForReport(data) {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = (factory.find(y => x == y.value)) == undefined ? '' : factory.find(y => x == y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x == y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x == y.value).label
            productName.push(filterProduct);
        })

        let groups = group.find(x => x.groupID == formik.values.groupID)

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.filter(x => x !== '').join(','),
            productCategoryID: categoryName.map(x => x).join(','),
            productID: productName.map(x => x).join(',')
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const getFillRate = (row) => {
        const suppliedQty = parseFloat(row.suppliedQty);
        const orderedQty = parseFloat(row.orderedQty);

        const fillRate = ((suppliedQty / orderedQty) * 100);
        return parseFloat(fillRate).toFixed(2);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="SKU Wise Quantity Bought against Purchase Order |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/purchasingHistoryReport"}
                        btname="Add"
                        pageName="SKU Wise Quantity Bought against Purchase Order"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            style: {
                                                height: "48px",
                                                width: "100%"
                                            },
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group *</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}

                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.productCategoryID && errors.productCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            disabled={selectedOptions.length == 0}
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productCategoryID && errors.productCategoryID && (
                                            <FormHelperText>{errors.productCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.productID && errors.productID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product"
                                            disabled={selectedCategoryOptions.length == 0}
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                            style={{ width: '300px' }}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productID && errors.productID && (
                                            <FormHelperText>{errors.productID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '90px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="From Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />}

                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="To Date *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />}

                                        />
                                    </LocalizationProvider>

                                    <br />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {reportData.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                                <TableContainer component={Paper} >
                                                    <Table aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="left">Date</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="left">FCC</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="left">SKU Code</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="left">SKU Description</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="right">Ordered Qty</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="right">Supplied Qty</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="right">Fill Rate</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {(rowsPerPage > 0
                                                                ? reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                : reportData).map((row) => (
                                                                    <TableRow>
                                                                        <TableCell align="left">{moment(row.orderDate).format("YYYY-MM-DD")}</TableCell>
                                                                        <TableCell align="left">{row.factoryName}</TableCell>
                                                                        <TableCell align="left">{row.skuCode}</TableCell>
                                                                        <TableCell align="left">{row.skuDescription}</TableCell>
                                                                        <TableCell align="right">{row.orderedQty == 0 ? '-' : parseFloat(row.orderedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>                                                                        
                                                                        <TableCell align="right">{row.suppliedQty == 0 ? '-' : parseFloat(row.suppliedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                                                                        <TableCell align="right">{getFillRate(row) == 0 ? '-' : parseFloat(getFillRate(row)).toFixed(2)}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: "bold" }} colSpan={4}>Total</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="right">{totalValues.totalOrderedQty == 0 ? '-' : parseFloat(totalValues.totalOrderedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="right">{totalValues.totalSuppliedQty == 0 ? '-' : parseFloat(totalValues.totalSuppliedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                                                                <TableCell sx={{ fontWeight: "bold" }} align="right">{totalValues.totalFillRate == 0 ? '-' : parseFloat(totalValues.totalFillRate).toFixed(2)}</TableCell>

                                                            </TableRow>
                                                            {emptyRows > 0 && (
                                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                                    <TableCell colSpan={6} />
                                                                </TableRow>
                                                            )}
                                                        </TableBody>
                                                        <TableFooter>
                                                            <TableRow>
                                                                <TablePagination
                                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                    colSpan={7}
                                                                    count={reportData.length}
                                                                    rowsPerPage={rowsPerPage}
                                                                    page={page}
                                                                    SelectProps={{
                                                                        inputProps: {
                                                                            'aria-label': 'rows per page',
                                                                        },
                                                                        native: true,
                                                                    }}
                                                                    onPageChange={handleChangePage}
                                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                                    ActionsComponent={TablePaginationActions}
                                                                />
                                                            </TableRow>
                                                        </TableFooter>

                                                    </Table>
                                                </TableContainer>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="SKU Wise Quantity Bought against the Purchase Order" />}</>
                        </Form>
                    </FormikProvider>
                    {reportData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <div>&nbsp;</div>
                            <style>
                                {`
                                 @page  {
                                            size: A4 landscape; 
                                            margin: 20mm;
                                        }
                               `}
                            </style>
                            <ReactToPrint
                                documentTitle={"SKU Wise Quantity Bought Against the Purchase Order"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    reportData={reportData}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                    getFillRate={getFillRate}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}

